// extracted by mini-css-extract-plugin
export var caseStudies = "case-studies-index-module--case-studies--1204b";
export var featuredPosts = "case-studies-index-module--featured-posts--2f26f";
export var featuredSection = "case-studies-index-module--featured-section--24162";
export var heroPost = "case-studies-index-module--hero-post--0e59b case-studies-index-module--postcard--24406";
export var postcard = "case-studies-index-module--postcard--24406";
export var subjectSection = "case-studies-index-module--subject-section--619e5";